import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class ApplicantTypeService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/applicant-cancellation-reasons`, options);
  }
}

export default ApplicantTypeService;
